import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSearchParams } from "react-router-dom";
import useAdminAgentService from "../hooks/useAdminAgentService";

const AgentInstructionsContext = createContext();

export const AgentInstructionsProvider = ({ children }) => {
  const [agentNumber, setAgentNumber] = useState(null);
  const [agentName, setAgentName] = useState("");
  const [agentSummary, setAgentSummary] = useState("");
  const [agentInstructions, setAgentInstructions] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getAgentInstructions } = useAdminAgentService();

  // Get agent number from query parameters
  const [searchParams] = useSearchParams();
  const agentNumberFromUrl = searchParams.get("agentNumber");

  useEffect(() => {
    const fetchAgentInstructions = async () => {
      if (!agentNumberFromUrl) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await getAgentInstructions(agentNumberFromUrl);

        if (response && response.error) {
          setError(response.error);
        } else if (response) {
          setAgentNumber(agentNumberFromUrl);
          setAgentName(response.agentName || "");
          setAgentSummary(response.agentSummary || "");
          setAgentInstructions(response.agentInstructions || "");
        } else {
          setError("No data received");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentInstructions();
  }, [agentNumberFromUrl, getAgentInstructions]);

  return (
    <AgentInstructionsContext.Provider
      value={{
        agentNumber,
        agentName,
        agentSummary,
        agentInstructions,
        loading,
        error,
      }}
    >
      {children}
    </AgentInstructionsContext.Provider>
  );
};

export const useAgentInstructions = () => useContext(AgentInstructionsContext);

AgentInstructionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
